import { Session } from 'smg/customer-api/session';
import { Relref } from '../../hugo';

if (document.body.id.includes('account')) {
    void main();
}

async function main() {
    const $timeOfDay = document.querySelectorAll<HTMLElement>('.time-of-day');
    const $userFirstName = document.querySelectorAll<HTMLElement>('.user-first-name');

    await Session().
        then(sess => {
            if (!sess) {
                window.location.href = Relref('/');
                return;
            }
            if ($timeOfDay) {
                const hour = new Date().getHours();
                if (hour < 12) {
                    $timeOfDay.forEach($el => $el.innerText = 'Morning');
                } else if (hour < 18) {
                    $timeOfDay.forEach($el => $el.innerText = 'Afternoon');
                } else {
                    $timeOfDay.forEach($el => $el.innerText = 'Evening');
                }
            }

            if ($userFirstName) {
                $userFirstName.forEach($el => $el.innerText = sess.firstName);
            }

            document.querySelectorAll<HTMLElement>('.greeting').forEach($el => $el.classList.remove('d-none'));
        }).
        catch(() => {
            window.location.href = Relref('/');
            return;
        });
}
